import { render } from "./piano.svg?vue&type=template&id=2665a52f?inline"
const script = {}

import exportComponent from "/home/runner/work/ClementRivaille.github.io/ClementRivaille.github.io/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__